<template>
	<div>
		<myheader headTitle="通知设置"></myheader>
		<div class="all_main">
			<div class="all_content_nopadding">
				<div class="text12 textcolor999" style="padding: .5rem .8rem;">邮件通知</div>
				<div class="all_height_line24 backgroundC_white display_flex">
					<span class="text14 textcolor333 all_line_height24 display_inline_block"
						style="width: 77%;padding-left: .8rem;">接收邮件通知</span>
					<van-switch v-model="allowMail" style="margin: .45rem .5rem;" @change="setEmailAndSms()" />
				</div>
				<!-- <div class="all_height_line24 backgroundC_white display_flex">
					<span class="text14 textcolor333 all_line_height24 display_inline_block"
						style="width: 77%;padding-left: .8rem;">签约完成通知</span>
					<van-switch v-model="signedEmail" style="margin: .45rem .5rem;" @change="setEmail()" />
				</div> -->
				<div class="text12 textcolor999 margin_top_10" style="padding: .5rem .8rem;">短信通知</div>
				<div class="all_height_line24 backgroundC_white display_flex">
					<span class="text14 textcolor333 all_line_height24 display_inline_block"
						style="width: 77%;padding-left: .8rem;">接收短信通知</span>
					<van-switch v-model="allowSms" style="margin: .45rem .5rem;" @change="setEmailAndSms()" />
				</div>
				<!-- <div class="all_height_line24 backgroundC_white display_flex">
					<span class="text14 textcolor333 all_line_height24 display_inline_block"
						style="width: 77%;padding-left: .8rem;">签约完成通知</span>
					<van-switch v-model="signedSms" style="margin: .45rem .5rem;" @change="setSms()" />
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Switch
	} from 'vant';
	import{
		getUserInfo
	} from "../../utils/shareRequest.js"
	export default {
		components: {
			[Switch.name]: Switch,
		},
		data() {
			return {
				//邮箱待我方签约通知
				allowMail: this.$store.state.userInfo.config.allowMail,
				//短信待我方签约通知
				allowSms: this.$store.state.userInfo.config.allowSms,
				//邮箱待我方签约通知
				//signingEmail: this.$store.state.userInfo.signingEmail,
				//邮箱签约完成通知
				//signedEmail: this.$store.state.userInfo.signedEmail,
				//短信待我方签约通知
				//signingSms: this.$store.state.userInfo.signingSms,
				//短信签约完成通知
				//signedSms: this.$store.state.userInfo.signedSms,
			}
		},
		methods: {
			//邮件/短信通知设置
			setEmailAndSms() {
				let that = this
				this.$post('/my/api/saveConfig', {
						allowMail: this.allowMail,
						allowSms: this.allowSms,
						staffId: this.$store.state.userInfo.staffId
					})
					.then((res) => {
						if (res.success) {
							this.$Toast("修改成功！");
							getUserInfo()
						} else {
							this.$Toast(res.message || "修改失败！");
						}
					}).catch(err => {
						console.log('saveConfig', err)
						this.$Toast("修改失败！");
					})
			},
			//初始化
			init() {

			},
		},
		mounted() {
			this.init()
		}
	}
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";
</style>